import { Styles } from 'primase';
import {
  HEADER_MOBILE_HEIGHT,
  HEADER_DESKTOP_HEIGHT,
  FOOTER_DESKTOP_HEIGHT,
  FOOTER_MOBILE_HEIGHT_UPP,
  FOOTER_TABLET_HEIGHT_UPP,
  FOOTER_DESKTOP_HEIGHT_UPP,
} from './constants';

const SIZE_LARGE = Styles.spacing.sp1 * 22;
const BREAKPOINT_SM = `@media screen and (max-width: ${Styles.layout.Breakpoints.sm}px)`;

export const styles = {
  container: {
    minHeight: '100vh',
    background:
      window.env.P1_MYRISK_UPDATE === 'true'
        ? `var(--gradient-white-greyblue, linear-gradient(180deg, #FFF 21.78%, #E6EBF5 100%))`
        : Styles.color.neutral.neutral2,
    [`@media (max-width: ${Styles.layout.Breakpoints.sm}px)`]: {
      background: Styles.color.neutral.white,
    },
    ...(window.env.P1_MYRISK_UPDATE === 'true'
      ? {
          [`@media (width: ${Styles.layout.Breakpoints.sm}px)`]: {
            background: `var(--gradient-white-greyblue, linear-gradient(180deg, #FFF 21.78%, #E6EBF5 100%))`,
          },
        }
      : {}),
  },
  header: {
    backgroundColor: Styles.color.neutral.white,
    zIndex: 1,
  },
  background: {
    minHeight: `${SIZE_LARGE}px`,
    marginBottom: `-${SIZE_LARGE - Styles.spacing.sp1 * 3}px`,
  },
  content: {
    minHeight: `calc(100vh - ${HEADER_DESKTOP_HEIGHT}px - ${
      window.env.P1_MYRISK_UPDATE === 'true'
        ? FOOTER_DESKTOP_HEIGHT_UPP
        : FOOTER_DESKTOP_HEIGHT
    }px)`,
    padding: `0px ${Styles.spacing.sp6}px ${
      window.env.P1_MYRISK_UPDATE === 'true' ? 24 : Styles.spacing.sp8
    }px`,
    [`@media (max-width: ${Styles.layout.Breakpoints.md}px)`]: {
      minHeight: `calc(100vh - ${HEADER_DESKTOP_HEIGHT}px - ${
        window.env.P1_MYRISK_UPDATE === 'true' ? FOOTER_TABLET_HEIGHT_UPP : 0
      }px)`,
    },
    [`@media (max-width: ${Styles.layout.Breakpoints.sm}px)`]: {
      padding: 0,
      minHeight: `calc(100vh - ${HEADER_MOBILE_HEIGHT}px - ${
        window.env.P1_MYRISK_UPDATE === 'true' ? FOOTER_TABLET_HEIGHT_UPP : 0
      }px)`,
    },
    ...(window.env.P1_MYRISK_UPDATE === 'true'
      ? {
          [`@media (width: 768px)`]: {
            padding: `0px ${Styles.spacing.sp6}px 24px`,
          },
        }
      : {}),
    [`@media (max-width: ${Styles.layout.Breakpoints.xs}px)`]: {
      minHeight: `calc(100vh - ${HEADER_MOBILE_HEIGHT}px - ${
        window.env.P1_MYRISK_UPDATE === 'true' ? FOOTER_MOBILE_HEIGHT_UPP : 0
      }px)`,
    },
  },
  footer: {
    position: window.env.P1_MYRISK_UPDATE === 'true' ? undefined : 'absolute',
    left: '0',
    bottom: '0',
    width: '100%',
    [`@media (max-width: ${Styles.layout.Breakpoints.sm}px)`]: {
      marginTop: window.env.P1_MYRISK_UPDATE === 'true' ? undefined : '80px',
      position: window.env.P1_MYRISK_UPDATE === 'true' ? undefined : 'relative',
    },
  },
  title: {
    marginTop: 0,
    [BREAKPOINT_SM]: {
      fontSize: '24px',
      padding: '15px 0px 0px 24px',
      fontWeight: '600',
      marginBottom: '0px',
    },
    paddingBottom: '10px',
    fontWeight: '500',
    fontSize: '40px',
    marginBottom: '3px',
  },
  titleUPP: {
    marginTop: 0,
    '@media (width: 768px)': {
      padding: '0px',
      paddingBottom: '10px',
    },
    [BREAKPOINT_SM]: {
      fontSize: '1.5rem',
      padding: '24px 0px 0px 24px',
      fontWeight: '600',
      marginBottom: '0px',
    },
    paddingBottom: '10px',
    fontWeight: '500',
    fontSize: '2.5rem',
    marginBottom: '3px',
  },
  titleText: {
    fontWeight: '700',
    fontSize: '40px',
    letterSpacing: '-0.01em',
    [`@media screen and (max-width: ${Styles.layout.Breakpoints.sm}px)`]: {
      fontSize: '22px',
      fontWeight: '800',
    },
  },
  subTitle: {
    marginTop: Styles.spacing.sp1,
  },
  colonTitle: {
    fontWeight: 700,
    fontSize: '13px',
    textTransform: 'uppercase',
    color: Styles.color.gray[500],
    marginBottom: Styles.spacing.sp2,
  },
  wrapper: {
    maxWidth: '100%',
    width: 1032,
    margin: '40px auto',
    [BREAKPOINT_SM]: {
      margin: '0 auto',
    },
    ...(window.env.P1_MYRISK_UPDATE === 'true'
      ? {
          [`@media (width: ${Styles.layout.Breakpoints.sm}px)`]: {
            margin: '0 auto',
            marginTop: '40px',
          },
        }
      : {}),
  },
  wrapperUPP: {
    width: 'var(--contentMaxWidthCPP)',
  },
};

export default styles;
